import { create } from 'zustand';
import adminApi from '../services/adminApi';

export const useAuthStore = create((set, get) => ({
  user: null,
  token: localStorage.getItem('token'),
  isAuthenticated: !!localStorage.getItem('token'),

  login: async (email, password) => {
    try {
      const response = await adminApi.post('/auth/login', {
        email,
        password
      });

      const { user, access_token } = response.data.data;
      
      localStorage.setItem('token', access_token);
      
      set({
        user,
        token: access_token,
        isAuthenticated: true
      });

      return response.data;
    } catch (error) {
      throw new Error(error.response?.data?.message || 'Giriş başarısız');
    }
  },

  logout: () => {
    localStorage.removeItem('token');
    set({
      user: null,
      token: null,
      isAuthenticated: false
    });
  },

  checkAuth: () => {
    const token = localStorage.getItem('token');
    if (token) {
      set({
        token,
        isAuthenticated: true
      });
    } else {
      set({
        token: null,
        isAuthenticated: false,
        user: null
      });
    }
  }
}));

